var map = {
	"./P1_side_left.png": "0yUj",
	"./P2_side_left.png": "qA37"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "L+Wm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST ^\.\/.*_side_left\.png$
// module id = L+Wm
// module chunks = 3